import { styled } from '@mui/material'
import React, { useState } from 'react'
import { putUserUpdate } from 'src/api/User';
import AdChangeEmailModalContent from 'src/components/adminUserInfo/AdChangeEmailModalContent';
import AdChangePWModalContent from 'src/components/adminUserInfo/AdChangePWModalContent';
import { ActionButton, NextButton } from 'src/components/common/CommonStyled';
import { ModalTitleWrapper } from 'src/components/common/ModalStyled';
import InputBoxOnChange from 'src/components/inputbox/InputBoxOnChange';
import { useModalStore } from 'src/stores/ModalStore';
import { useStorageStore } from 'src/stores/StorageStore';
import { refetchUser } from 'src/utils/RefetchUser';

const PageWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    margin: '30px 30px',
    borderRadius: '10px',
    height: 'calc(100vh - 126px)', // 필요시 조정
    overflow: 'hidden', // 전체적으로 overflow 방지
  }));
  
const HeaderWrapper = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '32px',
  marginTop:'0px',
  marginBottom:'20px'
  }));

const ContentWrapper = styled('div')(({ theme }) => ({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  flexDirection:'column',
  gap:'20px',

  flexGrow: 1, // 남은 높이만큼 차지
  borderRadius: '5px',
  backgroundColor: 'white',
  boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.20)',
  width: '100%',
}));

const ContentContainer = styled('div')(({theme})=>({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  width:'600px',
  boxSizing:'border-box',
  gap:'40px'
}))

const TitleWrapper = styled('div')(({theme})=>({
  whiteSpace:'nowrap',
  minWidth:'56px'
}))

const AdUserInfoPage = () => {
  const storage = useStorageStore()
  const [userInfo] = useState(storage.getItem('user').data)
  const [name,setName] = useState(userInfo.user_name)
  const [phone,setPhone] = useState(userInfo.phone)
  const [email,setEmail] = useState(userInfo.email)
  const [ismodify,setIsmodify] = useState(false)
  const modalSetField = useModalStore((state)=>state.setField)

  const handleName = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setName(e.target.value)
  }
  const handlePhone = (e:React.ChangeEvent<HTMLInputElement>)=>{
    setPhone(e.target.value)
  }
  const handleModify = ()=>{
    setIsmodify(true)
  }  
  const modifySubmit = async()=>{
    await putUserUpdate({user_name:name,phone,email})
    await refetchUser()
    setIsmodify(false)
  }
  // 비밀번호 변경 모달
  const modalPasswordChange = ()=>{
    modalSetField('type','CENTER')
    modalSetField('width','552px')
    modalSetField('title',
      <ModalTitleWrapper style={{justifyContent:'center'}}>
        비밀번호 변경
      </ModalTitleWrapper>
    )
    modalSetField('content',
      <AdChangePWModalContent/>
    )
    modalSetField('open',true)
  }
  // 이메일 변경 모달
  const modalEmailChange = ()=>{
    modalSetField('type','CENTER')
    modalSetField('width','552px')
    modalSetField('title',
      <ModalTitleWrapper style={{justifyContent:'center'}}>
        이메일 변경
      </ModalTitleWrapper>
    )
    modalSetField('content',
      <AdChangeEmailModalContent setEmailState={setEmail}/>
    )
    modalSetField('open',true)
  }

  return (
    <PageWrapper>
        <HeaderWrapper>관리자 정보</HeaderWrapper>
        <ContentWrapper>
          <ContentContainer>
            <TitleWrapper>아이디</TitleWrapper>
            <InputBoxOnChange height='56px' placeholder={userInfo.user_id} disabled={true}/>
          </ContentContainer>
          <ContentContainer style={{gap:'10px'}}>
            <TitleWrapper style={{marginRight:'30px'}}>비밀번호</TitleWrapper>
            <InputBoxOnChange height='56px' placeholder={'**********'} disabled={true}/>
            <ActionButton style={{padding:'17px 20px'}} onClick={modalPasswordChange}>변경</ActionButton>
          </ContentContainer>
          <ContentContainer>
            <TitleWrapper>이름</TitleWrapper>
            <InputBoxOnChange height='56px' value={name} onChange={handleName} disabled={!ismodify}/>
          </ContentContainer>
          <ContentContainer>
            <TitleWrapper>연락처</TitleWrapper>
            <InputBoxOnChange height='56px' value={phone} onChange={handlePhone} disabled={!ismodify}/>
          </ContentContainer>
          <ContentContainer style={{gap:'10px'}}>
            <TitleWrapper style={{marginRight:'30px'}}>이메일</TitleWrapper>
            <InputBoxOnChange height='56px' placeholder={email} disabled={true}/>
            <ActionButton style={{padding:'17px 20px'}} onClick={modalEmailChange}>변경</ActionButton>
          </ContentContainer>
          <div style={{height:'64px'}}>
            {!ismodify ? <NextButton style={{width:'600px', padding:'20.5px'}} onClick={handleModify}>수정</NextButton> :
            <NextButton style={{width:'600px', padding:'20.5px'}} onClick={modifySubmit}>수정 완료</NextButton>}   
          </div>
        </ContentWrapper>
    </PageWrapper>
  )
}

export default AdUserInfoPage